import { render, staticRenderFns } from "./DoubleCircleIcon.vue?vue&type=template&id=01463f4a&scoped=true"
import script from "./DoubleCircleIcon.vue?vue&type=script&lang=js"
export * from "./DoubleCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01463f4a",
  null
  
)

export default component.exports